"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/07/23
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./namespaces/activity"), exports);
tslib_1.__exportStar(require("./namespaces/auth"), exports);
tslib_1.__exportStar(require("./namespaces/files"), exports);
tslib_1.__exportStar(require("./namespaces/resources"), exports);
tslib_1.__exportStar(require("./namespaces/system"), exports);
//# sourceMappingURL=index.js.map